import { render, staticRenderFns } from "./BestTrainers.vue?vue&type=template&id=51b3c5da&"
import script from "./BestTrainers.vue?vue&type=script&lang=js&"
export * from "./BestTrainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BestTrainers.vue"
export default component.exports